import { render, staticRenderFns } from "./LeftSection.vue?vue&type=template&id=5be0ec62&scoped=true"
import script from "./LeftSection.vue?vue&type=script&lang=js"
export * from "./LeftSection.vue?vue&type=script&lang=js"
import style0 from "./LeftSection.vue?vue&type=style&index=0&id=5be0ec62&prod&lang=scss"
import style1 from "./LeftSection.vue?vue&type=style&index=1&id=5be0ec62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0ec62",
  null
  
)

export default component.exports